<template>
  <span>

    <span @click="showAddSection"><slot></slot></span>

    <b-modal v-model="modalAdd" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('TEMPLATES.ADD_DOCUMENT.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEMPLATES.ADD_DOCUMENT.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4 pt-2" v-if="modalLoading === false">
        
          <div class="form-group row">
            <b-form-group :label="$t('TEMPLATES.ADD_DOCUMENT.INPUT_PUBLISH')">
              <b-form-radio-group id="addFormPublish" autofocus  v-on:keyup.enter="addDocument" v-model="addFormPublish" name="publish">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('TEMPLATES.ADD_DOCUMENT.INPUT_PUBLIC')">
              <b-form-radio-group id="addFormPublic" v-on:keyup.enter="addDocument" v-model="addFormPublic" name="public">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalLoading === false">
          <b-btn @click="hideAddSection">{{ $t('CLOSE')}}</b-btn>

          <b-button
            variant="primary"
            class="btn-fill"
            @click="addDocument"
          >{{ $t('TEMPLATES.ADD_DOCUMENT.ADD')}}</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      modalAdd: false,
      modalLoading: false,
      addFormPublish: 1,
      addFormPublic: 1,
      selected: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showAddSection() {
      this.modalAdd = true;
    },
    hideAddSection() {
      this.modalAdd = false;
      this.sectionName = "";
      this.modalLoading = false;
    },
    addDocument: function() {
      let self = this;
      this.modalLoading = true;
      this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/create", {
          documentId: this.item.template.id,
          publish: this.addFormPublish,
          public: this.addFormPublic
        })
        .then(function(response) {
          self.hideAddSection();
          self.$emit("update",{ document: response.data.document, documentVersion: response.data.documentVersion });
          if (self.addFormPublish === 0) {
            self.$noty.info(self.$t("TEMPLATES.ADD_DOCUMENT.SUCCESS.CREATED_DRAFT"));
          } else {
            self.$noty.info(self.$t("TEMPLATES.ADD_DOCUMENT.SUCCESS.CREATED_PUBLISH"));
          }
        })
        .catch(function(error) {
          self.modalLoading = false;
          self.$noty.error(self.$t(error.response.data));
        });
    }
  },
  computed: {
    documentName() {
      return (
        this.details.document.name + ":" + this.details.documentVersion.version
      );
    }
  }
};
</script>
<style>
</style>